<template>
    <div class="foot_mian">
        <el-row class="footer_nav" v-if="showFooterLink">
            <div class="footer_nav_out clear">
                    <el-col :span="9">
                        <img class="footerIconLogo" src="../../assets/logo.png" alt="">
                        <div class="logo_text">
                            Beny improves the wellbeing of organisations and <br/>
                            their teams with simple and valuable benefits that <br/>
                            support them from nine to thrive. Become a friend of <br/>
                            Beny to unlock leading benefits, and help create a <br/>
                            mentally healthier Australia.
                        </div>
                        <div class="btm-picture"></div>
                    </el-col>
                    <el-col :span="5">
                        <div class="footer_title margin_footer">Product</div>
                        <div class="footer_pramyText margin_footer footer_cursor" @click="go(1)">How it works</div>
                        <div class="footer_pramyText margin_footer footer_cursor" @click="go(2)">Benefits</div>
                        <div class="footer_pramyText margin_footer footer_cursor" @click="go(3)">Charity</div>
                        <div class="footer_pramyText margin_footer footer_cursor" @click="go(4)">Pricing</div>
                        <!--<div class="footer_pramyText footer_cursor" @click="go(5)">Live Demo</div>-->
                    </el-col>
                    <el-col :span="5">
                        <div class="footer_title margin_footer">Resources</div>
                        <!--<div class="footer_pramyText margin_footer footer_cursor">Documentation</div>
                        <div class="footer_pramyText margin_footer footer_cursor">Blog</div>
                        <div class="footer_pramyText margin_footer footer_cursor">Careers</div>-->
                        <div class="footer_pramyText margin_footer footer_cursor underline" @click="jump('https://hello.beny.com.au/#/privacy-policy')">Privacy Policy</div>
                        <div class="footer_pramyText margin_footer footer_cursor underline" @click="jump('https://hello.beny.com.au/#/terms-conditions')">Terms</div>
                    </el-col>
                    <el-col :span="5">
                        <div class="footer_title margin_footer">Contact Us</div>
                        <!--<div class="footer_pramyText margin_footer footer_cursor">Live Chat</div>-->
                        <div class="footer_pramyText margin_footer footer_cursor underline" @click="contactShow(true)">Contact</div>
                    </el-col>
            </div>
        </el-row>
        <el-row class="footer-bar">
            <div class="foot_tpxs clear">
                <span class="foot_tpxs-item footer_cursor" @click="goLink(2)">Privacy policy</span>
                <span class="foot_tpxs-item footer_cursor" @click="goLink(1)">Terms of use</span>
            </div>
        </el-row>

        <contact :show="showContact" @close="contactShow" />
    </div>
</template>

<script>
import contact from './contact.vue'

export default {
    name:'FooterBar',
    props:{
        showFooterLink:{
            type:Boolean,
            default:()=>{
                return true
            }
        }
    },
    data () {
        return {
            showContact: false
        }
    },
    methods:{
        jump(path) {
            window.open(path, '_blank')
        },
        goLink(key){
            if(key===1){
                window.open('https://hello.beny.com.au/#/terms-conditions',"_target")
            }else{
                window.open('https://hello.beny.com.au/#/privacy-policy',"_target")
            }
        },
        go(key){
            switch (key) {
                case 1:
                    this.$router.push('/works')
                    break;
                case 2:
                    this.$router.push('/benefits')
                    break;
                case 3:
                    this.$router.push('/monthlyCharity')
                    break;
                case 4:
                    this.$router.push('/pricing')
                    break;
            }
        },
        contactShow(boo) {
            this.showContact = boo
        }
    },
    components: {
        contact
    }
}
</script>

<style lang="scss" scoped>
.foot_mian{
    .footer_nav{
        // display: flex;
        .footer_nav_out{
            width:1300px;margin:0 auto;padding-left:2%;
        }
        background-color: #3a3835;
        padding:89px 0 119px 0;
        .footerIconLogo{
            width: 65px;
            height: 31px;
            opacity: 1;
            border-radius: 0px;
            margin-bottom: 18px;
        }
        .btm-picture{
            width: 100%;
            height: 100px;
            background-image: url('../../assets/yeah.png');
            background-position: left center;
            background-size: contain;
            background-repeat: no-repeat;
        }
        .logo_text{
            font-size: 16px;
            font-family: Assistant-Medium, Assistant;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 20px;
            margin-bottom: 10px;
        }
        .footer_title{
            height: 25px;
            font-size: 20px;
            font-family: Lora-Roman, Lora;
            font-weight: normal;
            line-height: 25px;
            color: #FFFFFF;
        }
        .footer_pramyText{
            font-size: 16px;
            font-family: Assistant-Medium, Assistant;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 20px;
            margin-bottom: 32px;
        }
        .underline{
            text-decoration: underline;
        }
        .margin_footer{
            margin-bottom: 19px;
        }
    }
    .footer_cursor{
        cursor: pointer;
    }
    .footer-bar{
        display: flex;
        align-items: center;
        height: 64px;
        background-color: #32312E;
        // padding: 0 50px;
        // position: fixed;
        // bottom: 0;
        .copy_tit{
            flex: 0.8;
            font-size: 15px;
            color: #fff;
        }
        .foot_tpxs{
            width: 1080px;
            margin: 0 auto;
            .foot_tpxs-item{
                // flex: 1;
                text-align: right;
                font-size: 15px;
                color: #fff;
                float: right;
                margin-left: 30px;
            }
        }
    }
}   
</style>


// WEBPACK FOOTER //
// src/components/common/footer-bar.vue